import React, { useState } from 'react';
import BEMHelper from '@ynap/bem-helper';
import { Link } from '@ynap/router';
import PropTypes from 'prop-types';
import Notification from '@ynap/notification/src/Notification/Notification';

const bem = new BEMHelper('WIWLinkInformation');

const WIWLinkInformation = (props) => {
    const { WIWProductRec, messages, optimizely } = props;
    const [hoveredItem, setHoveredItem] = useState(null);

    const trackEvent = () => {
        optimizely.track('OOD_CTR');
    };

    return (
        <>
            <div className={bem('titleLinks')}>{messages?.accordionWiwInformation?.title()}</div>
            <div className={bem('wiwContainer')}>
                {WIWProductRec?.[0].products.map((value, index) => {
                    const { badge } = value;
                    const isSoldOut = value?.displayable && !value?.visible;
                    const isItemUnavailable = !value?.displayable;
                    const category = value?.description.split(' ');
                    const soldOutBadge = isSoldOut && badge?.label;

                    const handleClick = (event) => {
                        if (isItemUnavailable) {
                            event.preventDefault();
                        } else {
                            trackEvent();
                        }
                    };

                    return (
                        <Link
                            key={value.href}
                            to={value?.href}
                            className={bem('designersContainer', isSoldOut ? 'isSoldOut' : isItemUnavailable && 'unavailable')}
                            onMouseEnter={() => setHoveredItem(index)}
                            onMouseLeave={() => setHoveredItem(null)}
                            onClick={() => handleClick(isItemUnavailable)}
                        >
                            <div className={bem('designerName')}>{value?.designer}</div>
                            <div className={bem('masterCategory')}>{category[category.length - 1]}</div>
                            {soldOutBadge && hoveredItem === index && (
                                <Notification className={bem('stockBadgeNotification')} arrow="top" type="info" message={soldOutBadge} />
                            )}
                        </Link>
                    );
                })}
            </div>
        </>
    );
};

WIWLinkInformation.propTypes = {
    WIWProductRec: PropTypes.array.isRequired,
    messages: PropTypes.object,
    optimizely: PropTypes.object,
};

export default WIWLinkInformation;
